<template>
  <div class="invite-overlay" @click.self="close">
    <div class="invite-modal" role="dialog" aria-modal="true">
      <button type="button" class="invite-close" aria-label="סגירה" @click="close">
        <LtIcon name="close" :size="16" />
      </button>

      <div class="invite-icon-wrap">
        <div class="invite-icon">
          <LtIcon name="music" :size="32" />
        </div>
        <div class="invite-sparkle invite-sparkle--1"><LtIcon name="sparkles" :size="16" /></div>
        <div class="invite-sparkle invite-sparkle--2"><LtIcon name="sparkles" :size="12" /></div>
      </div>

      <h2 class="invite-title">הגיע הזמן ליצור לינקטון!</h2>
      <p class="invite-sub">
        הפכו את המוזיקה שלכם לנגישה לקהל חדש.<br>
        צרו לינקטון, בחרו עיצוב והגישו לאישור — הכל במקום אחד.
      </p>

      <div class="invite-actions">
        <button type="button" class="invite-btn invite-btn--primary" @click="goToLinktones">
          <span>קדימה, בואו ניצור</span>
          <LtIcon name="arrow-left" :size="16" />
        </button>
        <button type="button" class="invite-btn invite-btn--ghost" @click="close">אולי אחר כך</button>
      </div>
    </div>
  </div>
</template>

<script>
import LtIcon from './my_linktones/LtIcon.vue';

export default {
  name: 'CreateLinktoneInvite',
  components: { LtIcon },
  emits: ['close', 'go'],
  methods: {
    close() {
      this.$emit('close');
    },
    goToLinktones() {
      this.$emit('go');
    },
  },
};
</script>

<style lang="scss" scoped>
.invite-overlay {
  --c-pink-50: #FFF1F6;
  --c-pink-100: #FFE0EC;
  --c-pink-200: #FFC2D8;
  --c-pink-300: #FF94B8;
  --c-pink-400: #FF5C92;
  --c-pink-500: #EC2872;
  --c-pink-600: #D11A60;
  --c-pink-700: #B01250;
  --c-ink-900: #1A1A22;
  --c-ink-700: #3F3F4E;
  --c-ink-500: #6B6B7B;
  --c-ink-300: #B5B5BF;
  --c-ink-200: #DCDCE4;
  --c-ink-100: #ECECF1;
  --c-ink-50: #F4F4F8;
  --c-card: #FFFFFF;
  --c-violet-50: #F2EEFE;

  position: fixed;
  inset: 0;
  background: rgba(20, 20, 40, .42);
  backdrop-filter: blur(6px);
  z-index: 100000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  animation: inviteFade .2s ease;
}

.invite-modal {
  background: var(--c-card);
  border-radius: 28px;
  width: 100%;
  max-width: 440px;
  padding: 40px 36px 32px;
  box-shadow: 0 14px 40px rgba(20, 20, 40, .10), 0 4px 12px rgba(20, 20, 40, .05);
  animation: invitePop .3s cubic-bezier(.2, .7, .2, 1);
  text-align: center;
  position: relative;
}

.invite-close {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  background: var(--c-ink-50);
  color: var(--c-ink-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  transition: background .15s ease;

  &:hover {
    background: var(--c-ink-100);
  }
}

.invite-icon-wrap {
  position: relative;
  display: inline-block;
  margin-bottom: 20px;
}

.invite-icon {
  width: 72px;
  height: 72px;
  border-radius: 22px;
  background: linear-gradient(135deg, var(--c-pink-50) 0%, var(--c-violet-50) 100%);
  color: var(--c-pink-500);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: inviteIconPulse 2.5s ease-in-out infinite;
}

.invite-sparkle {
  position: absolute;
  color: var(--c-pink-400);
  animation: inviteSparkle 2s ease-in-out infinite;
}

.invite-sparkle--1 {
  top: -4px;
  right: -10px;
  animation-delay: .3s;
}

.invite-sparkle--2 {
  bottom: 2px;
  left: -8px;
  animation-delay: .8s;
}

.invite-title {
  font-size: 22px;
  font-weight: 800;
  color: var(--c-ink-900);
  margin: 0 0 10px;
  letter-spacing: -.01em;
}

.invite-sub {
  font-size: 14.5px;
  color: var(--c-ink-500);
  margin: 0 0 28px;
  line-height: 1.65;
}

.invite-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.invite-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 0 28px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 15.5px;
  white-space: nowrap;
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform .12s ease, box-shadow .18s ease, background-color .18s ease;
  width: 100%;
  max-width: 280px;

  &:active {
    transform: translateY(1px);
  }
}

.invite-btn--primary {
  background: var(--c-pink-500);
  color: #fff;
  box-shadow: 0 10px 24px rgba(236, 40, 114, .28);

  &:hover {
    background: var(--c-pink-600);
    box-shadow: 0 12px 28px rgba(236, 40, 114, .35);
  }
}

.invite-btn--ghost {
  background: transparent;
  color: var(--c-ink-500);
  font-weight: 500;
  font-size: 14px;
  height: 38px;
  padding: 0;

  &:hover {
    color: var(--c-ink-700);
  }
}

@keyframes inviteFade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes invitePop {
  from { transform: translateY(12px) scale(.97); opacity: 0; }
  to { transform: none; opacity: 1; }
}

@keyframes inviteIconPulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.06); }
}

@keyframes inviteSparkle {
  0%, 100% { opacity: .4; transform: scale(.85); }
  50% { opacity: 1; transform: scale(1.1); }
}

@media (max-width: 480px) {
  .invite-modal {
    padding: 32px 24px 24px;
  }

  .invite-title {
    font-size: 20px;
  }

  .invite-btn {
    max-width: 100%;
  }
}
</style>
